import userProfileStore from '../core/UserProfileStore';
import * as Styles from './styles';
import ProfileContent from './ProfileContent';

export default function ProfileContainer() {
  const iamUserProfile = userProfileStore((state:any) => state.iamUserProfile);
  const oktaUserProfile = userProfileStore((state:any) => state.oktaUserProfile);
  return (
    <Styles.ProfileContent>
      <ProfileContent oktaUser={oktaUserProfile} iamUser={iamUserProfile}></ProfileContent>
    </Styles.ProfileContent>
  );
}
